import type { ReactNode } from "react";

interface Props {
  icon: ReactNode;
  title: string;
  /** The sentence the HR sync composed, or null while it is still loading. */
  sentence: string | null;
  error: string | null;
  onAsk(): void;
  onRefresh(): void;
}

/** One record, stated plainly: the figure as the lead line, then a way to
 *  take it into the chat. */
export function RecordTab({ icon, title, sentence, error, onAsk, onRefresh }: Props) {
  const loading = sentence === null && error === null;
  return (
    <div className="record">
      <div className="icon">{icon}</div>
      <h3>{title}</h3>
      {loading ? (
        <p className="lead">
          <span className="dots">
            <span />
            <span />
            <span />
          </span>
        </p>
      ) : error ? (
        <p className="lead error">{error}</p>
      ) : (
        <p className="lead">{sentence}</p>
      )}
      <div className="actions">
        <button className="check" onClick={onAsk}>
          Ask about this
        </button>
        <button className="ghost" onClick={onRefresh}>
          Refresh
        </button>
      </div>
    </div>
  );
}
